import { BreadcrumbItem } from '../types/shared/Breadcrumb';

export const assessmentsBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Assessments',
    },
];
export const challengeGroupsBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Challenge Groups',
        link: '/challenge-groups',
    },
];

export const challengeGroupsChallengesBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Challenge Groups',
        link: '/challenge-groups',
    },
];

export const challengeGroupsChallengeBreadcrumb = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Challenge Groups',
        link: '/challenge-groups',
    },
    {
        name: '',
        link: ``,
    },
];

export const challengesBreadcrumb = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Challenges',
        link: '/challenges',
    },
    {
        name: '',
        link: ``,
    },
];

export const assessmentChallenges: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Assessments',
        link: '/assessments',
    },
];
export const submissionsBreadcrumbs: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Assessments',
        link: '/assessments',
    },
];

export const assessmentBreadcrumbs: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Assessments',
        link: '/assessments',
    },
    {
        name: 'Submissions',
        link: '',
    },
];

export const createAssessmentBreadcrumbs: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Assessments',
        link: '/assessments',
    },
    {
        name: 'Submissions',
        link: '',
    },
    {
        name: 'Assessing',
    },
];

export const editAssessmentBreadcrumbs: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Assessments',
        link: '/assessments',
    },
    {
        name: 'Submissions',
        link: '',
    },
    {
        name: 'Editing Assessment',
    },
];

export const usersBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Users/SMEs',
    },
];

export const singleUserBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Users/SMEs',
        link: '/users',
    },
];

export const adminUsersBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Admins',
    },
];

export const singleAdminUserBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Admins',
        link: '/admins',
    },
];

export const contactUsMessagesBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Contact Us Messages',
    },
];

export const singleContactUsMessageBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Contact Us Messages',
        link: '/contact-us-messages',
    },
];

export const singleChallengeApplicationBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Users',
        link: '/users',
    },
    {
        name: 'Applications',
    },
];

export const singleChallengeGroupBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
    {
        name: 'Challenge Groups',
        link: '/challenge-groups',
    },
];

export const challengeCalendarBreadcrumb: BreadcrumbItem[] = [
    {
        name: 'Dashboard',
        link: '/',
    },
];
